module.exports = __webpack_public_path__ + "static/media/denise.31f96433.jpg";